import { Slide, SnackbarOrigin } from "@mui/material"
import { TransitionProps } from "@mui/material/transitions"
import { atom } from "jotai"

export interface TransitionSnackbarState extends SnackbarOrigin {
  open: boolean
  Transition: React.ComponentType<
    TransitionProps & {
      children: React.ReactElement<any, any>
    }
  >
  message: string
  variant: TransitionSnackbarVariant
}

export type TransitionSnackbarVariant = "success" | "error" | "warning" | "info"

export const transitionSnackbarState = atom<TransitionSnackbarState>({
  open: false,
  Transition: Slide,
  message: "I love snacks",
  vertical: "bottom",
  horizontal: "center",
  variant: "success",
})
